const passwordManagerDisableAutofillProps = {
    'data-1p-ignore': true
};

export { passwordManagerDisableAutofillProps };
//# sourceMappingURL=passwordManagerDisableAutofillProps.mjs.map
